import { Drawer, Button, Typography, Box, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { useNotification } from 'src/context/notification-context';
import { X } from 'react-feather';
import { getScreenSize } from 'src/utils/getUtils';
import { useTheme } from '@mui/material/styles';
import FlatIcon, { FlatIconOptions } from 'src/components/ui/FlatIcon';

RightDrawer.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  open: PropTypes.bool.isRequired,
  setIsRightDrawerOpen: PropTypes.func.isRequired,
  otherProps: PropTypes.object,
};

export default function RightDrawer({ title, children, open, setIsRightDrawerOpen, ...otherProps }) {
  const { notificationHeight } = useNotification();
  const theme = useTheme();
  return (
    <Drawer
      variant='persistent'
      anchor='right'
      ModalProps={{
        BackdropProps: {
          invisible: false,
        },
      }}
      PaperProps={{
        sx: {
          top: notificationHeight,
          padding: '5px',
          [theme.breakpoints.down('sm')]: {
            height: `calc(100% - ${notificationHeight}px)`,
            maxHeight: `calc(100% - ${notificationHeight}px)`,
            position: 'fixed',
            width: '100vw',
          },
          [theme.breakpoints.up('sm')]: {
            height: `calc(${getScreenSize().height} - ${notificationHeight}px)`,
            maxHeight: `calc(${getScreenSize().height} - ${notificationHeight}px)`,
            width: 500,
          },
          borderLeft: '1px solid rgb(242, 244, 247)',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
      open={open}
      {...otherProps}>
      <div style={{ display: 'flex', flexDirection: 'column', padding: '5px' }}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <Typography
            variant='h6'
            gutterBottom>
            {title}
          </Typography>
          <Button
            style={{ marginLeft: 'auto', marginBottom: '5px' }}
            onClick={() => setIsRightDrawerOpen()}>
            <FlatIcon icon={FlatIconOptions.close} /> Fechar
          </Button>
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: `calc(${getScreenSize().height}px - ${notificationHeight}px - ${
            window.innerWidth <= 768 ? 0 : 100
          }px)`,
          maxHeight: `calc(${getScreenSize().height}px - ${notificationHeight}px - ${
            window.innerWidth <= 768 ? 0 : 100
          }px)`,
          padding: '0px 10px',
          overflow: 'auto',
        }}>
        {children}
      </div>
    </Drawer>
  );
}
